export function safeJsonParse(value: string): string | object {
  try {
    return JSON.parse(value.toLowerCase())
  } catch {
    return value
  }
}
